import { Div, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { useMarketingContent } from 'src/react_query'

export const PhoneVerificationTerms: React.FC<{
  shouldDisplaySMSOptInMessage: boolean
}> = props => {
  const { shouldDisplaySMSOptInMessage } = props
  const marketingContentQuery = useMarketingContent({
    enabled: shouldDisplaySMSOptInMessage,
    suspense: true,
  })
  const smsOptInMessage = marketingContentQuery.data?.SMSOptInMessage.content
  return (
    <Div>
      {shouldDisplaySMSOptInMessage && smsOptInMessage && (
        <Text
          type="footnote"
          content={smsOptInMessage}
          alignment="left"
          inset={{ top: 'x1', bottom: 'x1_5' }}
        />
      )}
      <Text
        type="footnote"
        content="Standard text messaging and data rates may apply."
        alignment="left"
      />
      <Text type={'footnote'} style={{ fontSize: '0.65rem' }}>
        This site is protected by reCAPTCHA and the Google{' '}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </Text>
    </Div>
  )
}
